import Marquee from "react-fast-marquee";

const DEFAULT_ITEMS = ["Aroma Care", "Ayurvedika", "Waxglow", "Hue Luxe", "180+ Beauty Essentials", "New Brands Every Month"];

export const EditorialMarquee = ({ items = DEFAULT_ITEMS }) => (
  <div className="border-y border-zinc-200 py-8 bg-zinc-50" data-testid="editorial-marquee">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic font-light text-3xl md:text-5xl text-zinc-300 mx-8 whitespace-nowrap">
            {item}
          </span>
          <span className="text-gold text-xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
